// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ImageWrapper_wrapper__P3j2T","inactive":"ImageWrapper_inactive__rO8rt","active":"ImageWrapper_active__e1fmF","fadeIn":"ImageWrapper_fadeIn__yVw49"};